export default __webpack_public_path__ + "static/media/section1-bg4.f32a570d.svg";